import { useEffect, useState } from "react";
import useAxios from "../../../utils/useAxios";
import { PageableDTO } from "../../../types/pageable";
import { URL } from "../../../libraries/http/url";
import { Predicates } from "../../../libraries/predicates/predicates";
import { AxiosInstance } from "axios";
import { MasterArtworkPrintingTechniqueState } from "../../../states/meta-artwork/printing-technique/data.type";

type SearchParams = {
  search?: string;
};

type PrintingTechniqueResponse =
  | PageableDTO<MasterArtworkPrintingTechniqueState[]>
  | MasterArtworkPrintingTechniqueState[];

export const fetchCollection = async ({
  search,
  axios,
}: SearchParams & { axios: AxiosInstance }) => {
  try {
    const searchParams = URL.createSearchParams({
      search,
      limit: 50,
    });

    const response = await axios.get<PrintingTechniqueResponse>(
      `/artwork-master/meta-artwork/printing-technique/?${searchParams.toString()}`,
    );

    return Predicates.parsePageableReponseToType(response);
  } catch (err) {
    console.error(err);
  }
  return [];
};

export default function useArtworkPrintingTechnique({ search }: SearchParams) {
  const axios = useAxios();
  const [data, setData] = useState<MasterArtworkPrintingTechniqueState[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      const response = await fetchCollection({
        search,
        axios,
      });

      setData(response);
      setIsLoading(false);
    };


    getData();
  }, [search]);

  return {data, isLoading}
}
